import React from 'react';
import PropTypes from 'prop-types';
import parseHTML, { convertNodeToElement } from 'react-html-parser';
import { Link as MuiLink } from '@material-ui/core';

import Prose from './Prose';

const TransformedElement = ({ type, name, attribs, children }) =>
  type === 'tag' && name === 'a' ? (
    <MuiLink key={attribs.href} href={attribs.href}>
      {children.map((child, i) => (
        <React.Fragment
          key={i} // eslint-disable-line react/no-array-index-key
        >
          {convertNodeToElement(child)}
        </React.Fragment>
      ))}
    </MuiLink>
  ) : undefined;

TransformedElement.propTypes = {
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  attribs: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

const EventDescription = ({ event }) =>
  event.description ? (
    <Prose>
      {parseHTML(
        event.description
          .replace('\n\n', '<br>')
          .replace(
            /(<br>)+/g,
            '<span style="display: block; height: 1.0em;"></span>'
          ),
        { transform: TransformedElement }
      )}
    </Prose>
  ) : (
    <></>
  );

EventDescription.propTypes = {
  event: PropTypes.object.isRequired,
};

export default EventDescription;
